import { render, staticRenderFns } from "./carViolationRecordList.vue?vue&type=template&id=153284f8&scoped=true"
import script from "./carViolationRecordList.vue?vue&type=script&lang=js"
export * from "./carViolationRecordList.vue?vue&type=script&lang=js"
import style0 from "./carViolationRecordList.vue?vue&type=style&index=0&id=153284f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153284f8",
  null
  
)

export default component.exports